import { ClassThemeProvider } from '@class-ui/theme';
import { useParams } from 'react-router-dom';

import { type LtiRoutesParams } from '../components/classroom/ClassroomRoutes';
import { SelectDeepLinkContent } from '../components/classroom/SelectDeepLinkContent';
import { ClassProvider } from '../context/ClassContext';

export const SelectDeepLink = () => {
    const params = useParams<LtiRoutesParams>();
    console.log('SelectDeepLink', params);
    const { classUuid } = params;
    return (
        <ClassThemeProvider>
            <ClassProvider classUuid={classUuid}>
                <SelectDeepLinkContent />
            </ClassProvider>
        </ClassThemeProvider>
    );
};
